import {coreApi} from './core'

export const contractsService = {
    async getContracts(params) {
        return await coreApi.get(`/contract`, {params})
    },
    delete: async (id) => coreApi.delete(`/contract/${id}`),
    create: (data) => coreApi.post(`/contract`, data),
    getCompanyById: async (id) => coreApi.get(`/waybill/company?companyid=${id}`),
    getEmpowById: async (id) => coreApi.get(`/empow/company?companyid=${id}`),
    getById: async (id) => coreApi.get(`/contract?id=${id}`),
    getAll: () => coreApi.get(`/contract`),
    paginate: async (offset) => coreApi.get(`/contract/${offset}`),
    update(data) {
        return coreApi.put(`/contract`, data)
    },
    contractPrint(id) {
        return coreApi.get(`contract/print/${id}`)
    },
    contractCompanyById(params) {
        return coreApi.get(`/contract/company`, {params})
    }
}